"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M22.8,1.82A5.48,5.48,0,0,0,18.5,0a5.5,5.5,0,0,0-4.33,1.86A5.32,5.32,0,0,0,13,5.57a6.23,6.23,0,0,1,4.05,2.1A6.49,6.49,0,0,1,18.39,13a7,7,0,0,1-.66,1.88,3.46,3.46,0,0,1,.27,1.2v1.34a.5.5,0,0,0,1,0V16.12c0-1.29,1.26-3.21,2.48-5.07s2.2-3.35,2.43-4.68A5.51,5.51,0,0,0,22.8,1.82ZM18.5,7.23a2,2,0,1,1,2-2A2,2,0,0,1,18.5,7.23Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M11,5.57A5.32,5.32,0,0,0,9.81,1.82,5.49,5.49,0,0,0,5.51,0,5.5,5.5,0,0,0,1.17,1.86,5.47,5.47,0,0,0,.1,6.38a15.36,15.36,0,0,0,2.58,5C3.83,13.1,5,14.87,5,16.12v1.34a.5.5,0,0,0,1,0V16.12A3.46,3.46,0,0,1,6.26,15a7.93,7.93,0,0,1-.65-1.91A6.47,6.47,0,0,1,6.9,7.72,6.26,6.26,0,0,1,11,5.57ZM3.52,5.2a2,2,0,1,1,2,2A2,2,0,0,1,3.52,5.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M16.29,8.32A5.48,5.48,0,0,0,12,6.5,5.5,5.5,0,0,0,7.66,8.36a5.47,5.47,0,0,0-1.07,4.52,15.36,15.36,0,0,0,2.58,5c1.14,1.71,2.32,3.48,2.32,4.73v.88a.5.5,0,1,0,1,0v-.88c0-1.29,1.26-3.21,2.48-5.07s2.2-3.35,2.43-4.68A5.51,5.51,0,0,0,16.29,8.32ZM12,13.94a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,12,13.94Z"
  })));
};

exports["default"] = _default;